<template>
  <div class="ims-meter">
    <div class="meter-label">
      <slot></slot>
    </div>
    <div class="meter-bar">
      <div :class="`meter-progress bg-${color}`" :style="`width:${calcWidth(total, current)}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      required: true
    },
    total: {
      required: true
    },
    color: {
      default() {
        return "";
      }
    }
  },
  methods: {
    calcWidth(total, current) {
      let percent = (parseInt(current) / parseInt(total)) * 100;
      percent = percent > 100 ? 100 : percent;

      return percent + "%";
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/utils/variables";
@import "../../scss/vendors/bootstrap-utils";

.ims-meter .meter-bar {
  background: #ddd;
  height: 4px;
  border-radius: 30px;
}

.ims-meter .meter-progress {
  background: #aaa;
  border-radius: 30px;
  height: 100%;
}

.ims-meter .meter-label {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
</style>